//import theme from '@ecp/common/src/style/theme/default';

const gnbDefault = { title: '', link: '', dot: false, bold: false, target: '_self' };

const gnbMobileDefault = { title: '', link: '', target: '_self' };

export { gnbDefault, gnbMobileDefault };
